import { lowerCase, startCase } from 'lodash';

import { Retailer } from 'codegen';

export const mapEnumToOptionsArray = <T extends object>(en: T) => {
  const options = Object.values(en).map((val) => ({ label: startCase(lowerCase(val)), value: val }));

  return options;
};

export const mapRetailersToSort = (retailers?: Retailer[]) => retailers
  ?.sort((a, b) => a.name.localeCompare(b.name))
  ?.map((retailer) => ({ ...retailer, label: retailer.name, value: retailer.id }));

export const mapTreeSelectIds = (id: number | string) => Number(String(id).split('-')[0]);
